import ready from 'domready';
const scrollMonitor = require('scrollmonitor');
import '../scss/index.scss';
import '../images/social.png';
class App {
    constructor() {
        this.loadedClass = 'loaded';
        this.header = document.querySelector('.site-header');
        this.headerInner = this.header.querySelector('.site-header__inner');
        this.headerHeight = this.headerInner.clientHeight;
        this.shareToggle = document.querySelector('.share-toggle');
        this.shareToggleActiveClass = 'share-toggle_active';
        this.scrollWatcherOfsset = -300;
        this.mq = window.matchMedia('(min-width: 1024px)');
    }
    offset(el) {
	    const rect = el.getBoundingClientRect(),
	    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
	    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
    handlePageLoad() {
        document.querySelector('body').classList.add(this.loadedClass);
    }
    handleShareToggleClick() {
        let shareToggleBtn = this.shareToggle.querySelector('.share-toggle__btn');
        shareToggleBtn.addEventListener('click', (e) => {
            this.shareToggle.classList.toggle(this.shareToggleActiveClass);
        });
    }
    initScrollWatch() {
        const $blocks = document.querySelectorAll('.info__item');

        $blocks.forEach(block => {
            let blockWatcher = scrollMonitor.create(block, this.scrollWatcherOfsset);
            blockWatcher.enterViewport(() => {
                block.classList.add('visible');
                let animatedElems = block.querySelectorAll('.animated');
                animatedElems.forEach(el => {
                    let animation = el.dataset.animation;
                    el.classList.add(animation);
                });
            });
        });
    }
    getContent() {
        const $blocks = document.querySelectorAll('.info__content');
        $blocks.forEach(block => {
            const id = block.dataset.backId;
            this.getBackData(id, block);
        });
    }
    async getBackData(id, el) {
        try {
            const url = isDev ? 'info.json' : `https://www.m24.ru/api/v2?type=back&id=${id}&format=json`;
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('данные бэка не получены');
            }
            const data = await response.json();
            el.innerHTML = data[0].html;
            this.fixHtmlContent($container);
        } catch (error) {
            console.log('Возникла проблема с получением данных: ', error.message);
        }
    }
    initShare() {
        const shareBtns = document.querySelectorAll('.share');
        shareBtns.forEach((buttons) => {
            let share = Ya.share2(buttons, {
                theme: {
                    services: 'vkontakte,odnoklassniki,facebook,twitter'
                }
            });
        });
    }
    init() {
        try {
            this.handlePageLoad();
            this.handleShareToggleClick();
            this.initScrollWatch();
            this.getContent();
            this.initShare();
        } catch(error) {
            alert(error);
        }
    } 
}

ready(() => {
    window.app = new App();
    window.app.init();
});